import { IGameState } from '../../../App'
import { prepareLevel } from '../../levels/util'
import { resetBonuses } from './helpers/reset-bonuses'

export default ({ bombs, level, levels }: IGameState): Partial<IGameState> => {
    if (!level) {
        return {}
    }

    if (level.moves.length === 0 &&
        level.spawns.bombs.length === 0 &&
        level.spawns.bonuses.length === 0 &&
        bombs.length === 0
    ) {
        if (levels.length === 0) {
            // finish game
            return {
                won: true,
            }
        } else {
            // next level
            const [nextLevel, ...rest] = levels
            return {
                level: prepareLevel(nextLevel),
                levels: rest,
                gameTime: 0,
                ...resetBonuses()
            }
        }

    }

    return {}
}


// WEBPACK FOOTER //
// ./src/game/bomber/rules/level-progress.rules.ts